import { ListItemButton, ListItemIcon, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../../redux/store";
import { RouteType } from "../../routes/RouteType";
import "./styles.scss";

type Props = {
  item: RouteType;
};

const SidebarItem = ({ item }: Props) => {
  const { appState } = useSelector((state: RootState) => state.appState);

  return item.sidebarProps && item.path ? (
    <ListItemButton
      component={Link}
      to={item.path}
      className={
        appState === item.state
          ? "list-item-button"
          : "list-item-button-inactive"
      }
    >
      <ListItemIcon className="list-item-icon">
        {item.sidebarProps.icon && item.sidebarProps.icon}
      </ListItemIcon>
      <Typography
        sx={{ fontWeight: appState === item.state ? 700 : 400 }}
        className="list-item-text"
      >
        {item.sidebarProps.displayText}
      </Typography>
    </ListItemButton>
  ) : null;
};

export default SidebarItem;
